<template>
  <v-layout justify-center>
    <v-flex xs12 md6>
      <v-card flat class="paco_gradient mt-5 pt-5 pb-2">
        <v-layout justify-center row wrap class="mb-5">
          <v-flex xs10 sm6 md8 lg6 text-xs-center>
            <v-btn
              block
              large
              @click="authStart()"
              color="paco_rouge boutonRond"
              dark
              class="login_button"
              :loading="authLoading"
            >Connexion</v-btn>

            <div v-if="userData">
              Compte&nbsp;
              <b>{{ userData.name }}</b>
              <span v-if="!userData.isAdmin">&nbsp;non autorisé à administrer</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import jwtDecode from "jwt-decode";
import firebase from "firebase/app";
import auth from "../auth";

export default {
  data() {
    return {};
  },

  computed: {
    authLoading() {
      return this.$store.state.authLoading;
    },
    jwt() {
      return this.$store.state.jwt;
    },
    userData() {
      if (this.jwt) {
        return jwtDecode(this.jwt);
      }
    }
  },

  methods: {
    // authentification
    authStart() {
      auth.authStart();
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style>
.login_button {
  font-size: 1.5em;
}
</style>
